/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(() => {
  const HINT_SELECTOR = '#variant-hinweis';

  function getHintRoots(scope = document) {
    return [...scope.querySelectorAll(HINT_SELECTOR)]
      .map((hint) => hint.closest('section') || document)
      .filter((root, index, roots) => roots.indexOf(root) === index);
  }

  function requestRefresh(scope = document) {
    getHintRoots(scope).forEach((root) => {
      root.dispatchEvent(new MouseEvent('click', { bubbles: false }));
    });
  }

  function scheduleRefresh(scope = document) {
    window.requestAnimationFrame(() => requestRefresh(scope));
    window.setTimeout(() => requestRefresh(scope), 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleRefresh(), { once: true });
  } else {
    scheduleRefresh();
  }

  document.addEventListener('change', () => scheduleRefresh(), true);
  document.addEventListener('input', () => scheduleRefresh(), true);
  document.addEventListener('shopify:section:load', (event) => scheduleRefresh(event.target));
})();
